import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "regular fira f-paragraph mb-21 wc-lg clamp-2" }

import { ref, watch, onUnmounted, onMounted } from "vue"
import type { Ref } from "vue"
import { useMenuStore } from "@/store/pinia/menu";
import CTA from '@/components/UI/CTA.vue';
import clearTimeoutHandler from "@/composables/clearTimeoutHandler";
import { computed } from "@vue/reactivity";

// REFS

export default /*#__PURE__*/_defineComponent({
  props: {
  description: {
    type: String,
  },
  isTransitioningStepOne: {
    type: Boolean,
  },
  link: {
    type: Object,
  }
},
  setup(__props) {

const props = __props

/**
 * @author Irakli Kandelaki
 */

// IMPORTS
const descriptionTyped: Ref<string> = ref('');
const descriptionTypedCounter: Ref<number> = ref(0);
const descriptionTypingMachineTO: Ref<number | null> = ref(null);
const triggerDescriptionOnChangeTO: Ref<number | null> = ref(null);
const showDescription: Ref<boolean> = ref(false)
const isCTAVisible: Ref<boolean> = ref(false)


//  REFS - TIMEOUTS
const showDescriptionTO: Ref<number | null> = ref(null);



// STORE
const store = useMenuStore();

// PROPS


// COMPUTED
const hasScrolled = computed(() => store.hasScrolled)

// METHODS
const typingMachine = (targetVal: string, speed: number): void => {
  if (descriptionTypedCounter.value < targetVal.length) {
    descriptionTyped.value += targetVal.charAt(descriptionTypedCounter.value);
    descriptionTypedCounter.value += 1;
    descriptionTypingMachineTO.value = window.setTimeout(() => {
      typingMachine(targetVal, speed)
    }, speed);

  }
}

const initTypingMachine = () => {
  clearTimeoutHandler(triggerDescriptionOnChangeTO.value);

  triggerDescriptionOnChangeTO.value = window.setTimeout(() => {

    descriptionTyped.value = '';
    descriptionTypedCounter.value = 0;
    clearTimeout(descriptionTypingMachineTO.value);
    typingMachine(props.description, 10);
    showDescription.value = true;
  }, 500);
}



onUnmounted(() => {
  clearTimeoutHandler(descriptionTypingMachineTO.value);
  clearTimeoutHandler(triggerDescriptionOnChangeTO.value);

})

watch(props, (ns) => {
  if (!hasScrolled.value) return;
  if (ns.isTransitioningStepOne) {
    initTypingMachine();
  }

}, {
  deep: true,
  immediate: true,
})

watch(hasScrolled, (ns) => {
  if (ns) {
    showDescriptionTO.value = window.setTimeout(() => {
      initTypingMachine();
    }, 100);
  }
}, {
  immediate: true,
})

watch(hasScrolled, (ns) => {
  if (ns) {
    showDescriptionTO.value = window.setTimeout(() => {
      initTypingMachine();
    }, 100);
  }
}, {
  immediate: true,
})

watch(() => props.isTransitioningStepOne, (ns) => {
  window.setTimeout(() => {
    isCTAVisible.value = !ns;
  }, 700);
}, {
  immediate: true,
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-slider__pagination--description flex column", { 'is-dark': _unref(store).isDark, 'transitioning-step-one': __props.isTransitioningStepOne }])
  }, [
    (showDescription.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["main-slider__pagination--description__inner main-slider-container", { 'is-cta-visible': isCTAVisible.value, 'ev-none': !isCTAVisible.value }])
        }, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(descriptionTyped.value), 1),
          (__props.link?.url)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: __props.link?.url
              }, {
                default: _withCtx(() => [
                  _createVNode(CTA)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})